import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { Heading } from "../Heading";


export class FormSection extends Div
{
    constructor(title: string, content: appendable[])
    {
        super("order__section");

        this.Append(
            new Heading(title, 2, "order__section-title"),
            new Div("radio-group").Append(
                ...content
            )
        );
    }
}
